import { ImmunitySerology } from "./ImmunitySerology";
import { MothersTypeRhFactor } from "./MothersTypeRhFactor";
import { StbbiScreening } from "./StbbiScreening";
import { Ultrasound } from "./Ultrasound";

class ComplementaryExaminations {
    public Hemoglobin0: string;
    public Hemoglobin0Date: Date;
    public Hemoglobin1: string;
    public Hemoglobin1Date: Date;
    public ThyroidStimulationHormoneValue0: string;
    public ThyroidStimulationHormoneValue1: string;
    public ThyroidStimulationHormoneValue2: string;
    public GlycemiaFasting: string;
    public GlycemiaPost50g: string;
    public GlycemiaPost75g: string;
    public GlycemiaOpen0: string;
    public GlycemiaOpen1: string;
    public Urine: string;
    public MothersTypeRhFactor: MothersTypeRhFactor;
    public WinrhoDate0: Date;
    public WinrhoDate1: Date;
    public StbbiScreening: StbbiScreening;
    public ImmunitySerology: ImmunitySerology;
    public T21ScreeningNuchalTranslucency: string;
    public RiskAccordingToQpspt21: string;
    public RiskAccordingToOther: string;
    public Ultrasounds: Ultrasound[];
    public IsAmniocentesis: boolean;
    public Results: string;
    public HasVaccinationPostPartumRubella: boolean;
    public HasVaccinationPostPartumChickenPox: boolean;
    public HasVaccinationInfluenza: boolean;

    constructor(fields?: Partial<ComplementaryExaminations>) {
        Object.assign(this, fields);
        this.MothersTypeRhFactor = new MothersTypeRhFactor(fields?.MothersTypeRhFactor);
        this.StbbiScreening = new StbbiScreening(fields?.StbbiScreening);
        this.ImmunitySerology = new ImmunitySerology(fields?.ImmunitySerology);
        this.Ultrasounds = fields?.Ultrasounds?.map(p => new Ultrasound(p)) ?? [];
    }
}

export { ComplementaryExaminations };
